import React from 'react'
import Navbar from '../Home/Navbar';
import Footer from '../Home/Footer';
import { CartProvider } from 'react-use-cart';
import Phone from './Phone';

function AllPhone() {
  return (
    <CartProvider>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <Phone/>
        <Footer/>
    </CartProvider>
  )
}

export default AllPhone;